import {
  type ComponentPropsWithoutRef,
  type ElementType,
  type ReactNode,
} from "react";
import Text, { type Color } from "./Text";

type Variant = "tera" | "giga" | "mega" | "kilo" | "hecto" | "deca";

type Weight = "medium" | "bold";

const variantTags: Record<Variant, ElementType> = {
  tera: "h1",
  giga: "h1",
  mega: "h2",
  kilo: "h3",
  hecto: "h4",
  deca: "h5",
};

type TitleProps<T extends ElementType = "h2"> = {
  children: ReactNode;
  variant?: Variant;
  weight?: Weight;
  color?: Color;
  as?: T;
  className?: string;
} & Omit<ComponentPropsWithoutRef<T>, "children" | "className" | "color">;

export default function Title<T extends ElementType = "h2">({
  children,
  variant = "kilo",
  as,
  ...props
}: TitleProps<T>) {
  const Tag = as || variantTags[variant];

  return (
    <Text variant={variant} as={Tag} {...props}>
      {children}
    </Text>
  );
}
